import type { Plugin } from 'vue'
import { filters } from '@/utils/filters'

export const globalProperties = {
  $filters: filters
}

export const VueGlobalPropertiesPlugin: Plugin = {
  install: (app) => {
    for (const i in globalProperties) {
      app.config.globalProperties[i] = globalProperties[i as keyof typeof globalProperties]
    }
  }
}
